import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).multiselect({
      nonSelectedText: $(this).data('non-selected-text') || I18n.t("multiselect.nothing_selected"),
      enableCaseInsensitiveFiltering: true});
  }
}
